<template>
  <div class="box">
    <van-steps direction="vertical" :active="1">
      <van-step>
        <p>发起申请提现</p>
      </van-step>
      <van-step>
        <p>银行处理中</p>
      </van-step>
      <van-step>
        <p>到账成功</p>
      </van-step>
    </van-steps>
    <div class="okBtn" @click="$router.back()">完成</div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.okBtn {
    padding: 10px 0;
    width: 100px;
    background: #fff;
    text-align: center;
    line-height: 20px;
    margin: 100px auto;
}
</style>
